export default {
  defaultTitle: {
    en: 'It’s the holiday season!',
  },
  notification: {
    en: 'Order by Dec. 11 to get your holiday gifts in time',
  },
  valentinesDayNotification: {
    en: 'Get your gifts in time! Order by January 29 at 11:59 EST.',
  },
  title: {
    en: '{discount}% off select products',
  },
  button: {
    en: 'Shop now',
  },
}
